import store from '@/store';
import { fetchProjectsSetTimezone } from '@/lib/timezones';
const SignIn = () => import(/* webpackChunkName: "auth" */ '@/components/sign-in');
const ResetPassword = () => import(/* webpackChunkName: "auth" */ '@/components/reset-password');
const EditPassword = () => import(/* webpackChunkName: "auth" */ '@/components/edit-password');

const ROUTES_NAMES = {
  SIGN_IN: 'signIn',
  RESET_PASSWORD: 'resetPassword',
  EDIT_PASSWORD: 'editPassword'
};

const authorizeAdmin = function authorizeAdmin(to, from, next) {
  if (store.getters['auth/isAdminOrSuperadmin']) {
    next();
  } else {
    next('not-found', { replace: true });
  }
};

const authenticateRequest = async function authenticateRequest(to, from, next) {
  store.commit('auth/restoreToken');
  if (store.getters['auth/isAuthenticated']) {
    if (Object.values(ROUTES_NAMES).indexOf(to.name) !== -1) {
      next(false);
    } else {
      await fetchProjectsSetTimezone(store, to, from);

      next();
    }
  } else if (Object.values(ROUTES_NAMES).indexOf(to.name) !== -1) {
    next();
  } else {
    store.commit('setBackToPath', to.fullPath);
    next('sign-in', { replace: true });
  }
};

const signOut = function signOut(to, from, next) {
  store.dispatch('auth/signOut').then(() => {
    store.commit('setBackToPath', '/');
    next('sign-in', { replace: true });
  });
  next();
};

const AUTH_ROUTES = [
  {
    path: '/sign-in',
    name: ROUTES_NAMES.SIGN_IN,
    component: SignIn
  },
  {
    path: '/reset-password',
    name: ROUTES_NAMES.RESET_PASSWORD,
    component: ResetPassword
  },
  {
    path: '/edit-password/:token',
    name: ROUTES_NAMES.EDIT_PASSWORD,
    component: EditPassword,
    props: true
  },
  {
    path: '/sign-out',
    name: 'sign-out',
    mode: 'abstract',
    beforeEnter: signOut
  }
];

export { authenticateRequest, authorizeAdmin, signOut, AUTH_ROUTES };
